import * as actionTypes from '../actions/actionTypes';

const initialState = {
  loading: false,
  dataAll: [],
  dataPersonal: [],
  message: null,
  organizations: [],
  groups: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CONTACTS_STORE:
      return {
        ...state,
        loading: action.payload.loading,
      };
    case actionTypes.CONTACTS_FAILURE:
      return {
        ...state,
        loading: action.payload.loading,
        message: action.payload.message,
      };

    case actionTypes.CONTACTS_SUCCESS: {
      const { dataAll, dataPersonal, type } = action.payload;
      let data;

      if (type === 'All') {
        data = 'dataAll';
      } else {
        data = 'dataPersonal';
      }

      return {
        ...state,
        loading: action.payload.loading,
        [data]: type === 'All' ? dataAll : dataPersonal,
      };
    }
    case actionTypes.CONTACTS_UPDATE: {
      const { dataAll, dataPersonal, type } = action.payload;
      let data;

      if (type === 'All') {
        data = 'dataAll';
      } else {
        data = 'dataPersonal';
      }

      return {
        ...state,
        loading: action.payload.loading,
        [data]: type === 'All' ? dataAll : dataPersonal,
      };
    }
    case actionTypes.CONTACT_SET_ORG_GROUPS:
      return {
        ...state,
        organizations: action.payload.organizations,
        groups: action.payload.groups,
      };
    case actionTypes.CONTACTS_RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
